<template>
	<div>
		<!-- header -->
		<Mynav></Mynav>
		<div class="wrapper">
			<div class="topBg">
				<p>GAMES</p>
			</div>
			<div class="New-content">
				<div class="New-items" v-for="(item,index) in NewList" :key="index"
					@click="Newclick('',`${item.type}`)">
					<div class="img-box">
						<img class="transition" :src="item.img" />
					</div>
					<div class="New-items-contnet">
						{{item.detail}}
					</div>
					<!-- date -->
					<!-- <div class="New-date">12 Mar 2021</div> -->
				</div>
			</div>
			<!-- pagination -->
			<div class="pagination">
				<el-pagination :current-page="currentPage" :page-size="9" layout="prev, pager, next"
					@current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" :total="1">
				</el-pagination>
			</div>
		</div>
		<!-- footer -->
		<Myfooter></Myfooter>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				currentPage: 1,
				NewList: [{
						img: require('../../assets/new/shapezio-small.jpg'),
						detail: 'Shapez.io is a game about building factories to automate the creation and processing of increasingly complex shapes across an infinitely expanding map.',
						type: 'shapez'
					},
					{
						img: require('../../assets/new/Crafttheworld-small.jpg'),
						detail: 'Craft The World is a unique sandbox strategy game, the mix of Dungeon Keeper, Terraria and Dwarf Fortress.Explore a random generated world populated by dangerous creatures, build a dwarf fortress, gather resources, and craft all the items, weapons, and armor you need.',
						type: 'crafttheworld'
					},
					{
						img: require('../../assets/new/Aground-small.jpg'),
						detail: 'As one of the last human survivors, you find yourself stranded on an uninhabited island. With a few other victims of the crash, can you craft, mine, and build your way to survival?',
						type: 'aground'
					},
					{
						img: require('../../assets/new/tangledeep-small.jpg'),
						detail: 'Enter the magical world of Tangledeep, a beautifully polished dungeon crawler inspired by classic 16-bit RPGs! Colorful characters, a unique job system, tons of skills, items, and diverse environments with deep, turn-based roguelike gameplay. A different adventure every time you play!',
						type: 'tangledeep'
					},
					{
						img: require('../../assets/new/tod-small.jpg'),
						detail: 'Tunnel of Doom is an action rogue-lite hybrid that mixes tower defense with melee and ranged combat gameplay. Randomly generated, every run is different as you guide Angel on a quest to rescue her husband. Gather resources, discover perks, and use what you find to battle waves of monsters.',
						type: 'tod'
					},
					{
						img: require('../../assets/new/lazr-small.jpg'),
						detail: 'A new era of physics based platforming is about to begin. Play as fusion powered killer android Lazr, facing off against rogue AI and mega-corporations in Alpha City One.',
						type: 'lazr'
					},
					{
						img: require('../../assets/new/Craftlandsworkshoppe-small.jpg'),
						detail: 'From the out-there imagination behind the Shoppe Keep series comes a brand-new fantasy business adventure set in the clouds. Craftlands Workshoppe is hiring! But can you run your store, master three noble crafts and solve the former owners mysterious disappearance?',
						type: 'craftlands'
					},
					{
						img: require('../../assets/new/dangerscavenger-small.jpg'),
						detail: 'Danger Scavenger is fast-paced action, cyberpunk-themed, roguelite skyline crawler. Blow up, cut, shoot enemy robots on the roofs of skyscrapers. Choose your way to higher levels, loot, buy stuff, upgrade yourself, fight against greedy corporations, be a rebel!',
						type: 'dangerscavenger'
					},
					{
						img: require('../../assets/new/bloodrite-small.png'),
						detail: '(PC)3D MMORPG\nRelease date: Nov,2010\nChina Taiwans top-earning 3D online game in 2011.\nRussias best-selling Chinese MMORPG in 2012.\nReleased in China,China Taiwan,Russia,South Korea,Southeast Asia',
						type: 'bloodrite'
					},
					{
						img: require('../../assets/new/kungfuheroes-small.png'),
						detail: '(PC)3D MMORPG\nRelease date: Mar, 2014.\nChina Taiwans top-earning 3D online game in 2014.\nReleased in China,China Taiwan,South Korea,Southeast Asia.',
						type: 'kungfuheroes'
					},
					{
						img: require('../../assets/new/sword-small.jpg'),
						detail: '(PC)3D Fighting Action RPG\nRelease date: Oct,2017.\nThe perfect combination of Chinese martial arts and 3D action combat, created a new game genre in China.\nMax MAU over 1000,000.',
						type: 'sword'
					},
					// {
					// 	img: require('../../assets/new/Reus-small.jpg'),
					// 	detail: 'In Reus, you control powerful giants to shape the planet to your will. You can create mountains, oceans, forests and more. Enrich your planet with plants, minerals and animal life. There is only one thing on the planet that you do not control: mankind, with all their virtues and and all their vices.',
					// 	type: 'reus'
					// },
					{
						img: require('../../assets/new/outofspace-small.jpg'),
						detail: 'Strategy co-op online multiplayer game about living on a spaceship with your roommates. Youll need to generate resources, take care of a deadly alien infestation, upgrade your appliances and build your sustainable space home. Living together is never easy, especially when you are in outer space!',
						type: 'outofspace'
					},
					// {
					// 	img: require('../../assets/new/Iratus-small.png'),
					// 	detail: 'Iratus: Lord of the Dead is a turn-based tactical roguelike RPG set in a dark fantasy universe. Lead an army of undead to help an angry necromancer in his quest to reach the surface world and bring death to the mortal realms!',
					// 	type: 'iratus'
					// },
					{
						img: require('../../assets/new/loong-small.png'),
						detail: '(PC)3D MMORPG\nRelease date: Oct,2009.\nTop 3 3D Online Games in China in 2009!Max DAU over 500,000.\nMax CCU over 180,000.\nReleased in 36 countries and regions around the world.',
						type: 'loong'
					},
				],
			}
		},
		created() {},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
		},
		methods: {
			Newclick(index, type) {
				if (type == 'aground') {
					//��·����router---index.js��������
					window.open('https://store.steampowered.com/app/876650/Aground/')
				} else if (type == 'crafttheworld') {
					window.open('https://www.wegame.com.cn/store/2000348/Craft_the_World')
				} else if (type == 'shapez') {
					window.open('https://store.steampowered.com/app/1318690/shapezio/')
				} else if (type == 'tangledeep') {
					//��·����router---index.js��������
					window.open('https://store.steampowered.com/app/628770/Tangledeep/')
				} else if (type == 'craftlands') {
					window.open(
						'https://store.steampowered.com/app/1197820/Craftlands_Workshoppe__Third_Person_Resource_Management_and_Trading_RPG/'
						)
				} else if (type == 'dangerscavenger') {
					window.open('https://store.steampowered.com/app/1169740/Danger_Scavenger/')
				} else if (type == 'bloodrite') {
					window.open('http://smzx.iwgame.com/')
				} else if (type == 'kungfuheroes') {
					window.open('http://gfyx.8yx.com/')
				} else if (type == 'sword') {
					window.open('http://xlx.8yx.com/Main/index.html')
				} else if (type == 'reus') {
					window.open('https://store.steampowered.com/app/222730/Reus/')
				} else if (type == 'outofspace') {
					window.open('https://store.steampowered.com/app/400080/Out_of_Space/')
				} else if (type == 'iratus') {
					window.open('https://store.steampowered.com/app/807120/Iratus_Lord_of_the_Dead/')
				} else if (type == 'loong') {
					window.open('http://loong.iwgame.com/')
				} else if (type == 'tod') {
					window.open('https://store.steampowered.com/app/1361840/Tunnel_of_Doom/')
				} else if (type == 'lazr') {
					window.open('https://store.steampowered.com/app/1181040/LAZR__A_Clothformer/')
				}
			},
			Godetail() {
				this.$router.push({
					path: '/newsDetail',
					query: {
						id: '1'
					}
				})
			},
			currentChange(e) {
				this.currentPage = e;
			},
			prevClick(e) {
				this.currentPage = e;
			},
			nextClick(e) {
				this.currentPage = e;
			}
		},
	}
</script>

<style scoped lang="scss">
	@import 'index';
</style>
